module.exports = __webpack_public_path__ + "images/disability.652ca110dd829cd84152acceb074e74c.svg";